import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
});

Vue.filter('date', function (value) {
  return value.substring(0,10);
});

Vue.filter('time', function (value) {
  return value.substring(11,16)
});

Vue.filter('csv', function (text) {
  return text
});

// error validate convert Japanese
const convertError = Vue.filter('convertError', function(text){
  if(text){
    text = text.replace('field is required', 'は必須です。')
    text = text.replace('The ','')
    text = text.replace(' field must be a valid email','形式が正しくありません。')
    text = text.replace(' field must be at least 6 characters','6文字以上で指定してください。')
    text = text.replace(' confirmation does not match','ドが一致しません。')
    text = text.replace(' field may only contain alphabetic characters','は英文字で指定ください。')
    text = text.replace(' field may not be greater than 15 characters','15文字以下で指定してください')
    text = text.replace(' field may not be greater than 64 characters','64文字以下で指定してください')
    text = text.replace(' field may not be greater than 256 characters','256文字以下で指定してください')
    text = text.replace(' field may not be greater than 255 characters','255文字以下で指定してください')
    text = text.replace('姓 は必須です。', '氏名は必須です。')
    text = text.replace('名 は必須です。', '氏名は必須です。')
    text = text.replace('サブスクライブ氏名は必須です。','サブスクライブ名は必須です。')
    text = text.replace(' field may only contain numeric characters', 'の形式が正しくありません。')
    text = text.replace('確認パスワードはドが一致しません。', '確認パスワードとパスワードが一致していません。')
    text = text.replace(' ', '')
    text= text.replace('はは', 'は')
    return text
  }
  else return ''
});

// email to long => cut to fit screen
const convertEmail = Vue.filter('convertEmail', function(text){
  if (text.length > 0) {
      text = text.trim()
      // text = text.replaceAll('\t','')
      if(text.length > 50){
          const arr = text.split('@')
          if(arr[1].length > 40){
              const arr1 = arr[1].split('.');
              arr1.forEach(value =>{
                  if(value.length > 40/arr1.length) value = value.substring(0,30/arr1.length - 3) + '...'
              })
              arr[1] = arr1.join('.')
          }
          if(arr[0].length > 40) arr[0] = arr[0].substring(0,50-arr[1].length) + '...'
          text = arr.join('@')
      }    
  }
  return text
})

const convertRequireID = Vue.filter('convertRequireID', function (text) {
  text = text.toString()
  return text.substring(0,6) + '-' + text.substring(6)
});
const convertFileNameReceive = Vue.filter('convertFileNameReceive', function (text) {
  text = text.toString()
  if(text.length > 150) return text.substring(0, 143) + '...' + text.substring(text.length-7, text.length)
  else return text
});
const convertFileNameSend = Vue.filter('convertFileNameSend', function (text) {
  text = text.toString()
  if(text.length > 70) return text.substring(0, 63) + '...' + text.substring(text.length-7, text.length)
  else return text
});



export default {
  convertError,
  convertEmail,
  convertRequireID,
  convertFileNameReceive,
  convertFileNameSend
}
